import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import { ContactProvider } from "@/context/ContactContext";
import SplashScreen from "@/components/SplashScreen";

// Pages
import HomePage from "@/pages/HomePage";
import PropertiesPage from "@/pages/PropertiesPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ProjectDetailPage from "@/pages/ProjectDetailPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [splashDone, setSplashDone] = useState(false);

  useEffect(() => {
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
      }
    };
    seedData();
    document.body.style.overflow = splashDone ? 'auto' : 'hidden';
    return () => { document.body.style.overflow = 'auto'; };
  }, [splashDone]);

  return (
    <ContactProvider>
      {!splashDone && <SplashScreen onDone={() => setSplashDone(true)} />}
      <div id="scroll-bar" />
      <div id="cursor-glow" />
      <div className="App min-h-screen" style={{ background: '#faf7f0' }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/properties/:type" element={<PropertiesPage />} />
            <Route path="/property/:id" element={<PropertyDetailPage />} />
            <Route path="/project/:id" element={<ProjectDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </ContactProvider>
  );
}

export default App;
